'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const css = require('../ItemActionButtons-style.scss');

function RequestPriceButton(props) {
    return (
        <div className={css.itemActionWidget}>
            <button
                className={props.requestButtonClass || 'button button-primary button-large'}
                onClick={props.onClick}
                data-tn="item-actions-request-information"
            >
                {props.requestButtonCopy || 'request price'}
            </button>
        </div>
    );
}

RequestPriceButton.propTypes = {
    requestButtonCopy: PropTypes.string,
    requestButtonClass: PropTypes.string,
    onClick: PropTypes.func.isRequired,
};

module.exports = RequestPriceButton;



// WEBPACK FOOTER //
// ./assets/js/components/ItemActionButtons/RequestPriceButton/RequestPriceButton.jsx